export default function Products() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-24 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="flex items-start gap-8 mb-6">
            <div className="flex flex-col gap-1">
              <span className="text-sm uppercase tracking-widest text-gray-500 writing-mode-vertical">OUR</span>
              <span className="text-sm uppercase tracking-widest text-gray-500 writing-mode-vertical">PRODUCTS</span>
            </div>
            <h2 className="text-6xl font-serif text-gray-900">Innovative Solutions</h2>
          </div>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* VPN Card - 2 columns */}
          <div className="lg:col-span-2 relative bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-10 min-h-[500px] overflow-hidden group hover:shadow-2xl transition-shadow duration-300">
            {/* Badge */}
            <div className="absolute top-8 left-8 w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-sm">VPN</span>
            </div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col justify-between pt-24">
              <div>
                <h3 className="text-6xl font-bold text-white mb-4 leading-tight">
                  Secure<br />Connection
                </h3>
                <p className="text-gray-400 text-base">Privacy-focused virtual private network</p>
              </div>

              {/* Icon */}
              <div className="flex justify-end">
                <div className="w-32 h-32 bg-white/5 backdrop-blur-sm rounded-3xl flex items-center justify-center">
                  <i className="ri-shield-keyhole-line text-6xl text-orange-500"></i>
                </div>
              </div>
            </div>

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          </div>

          {/* Cleaner Card - 3 columns */}
          <div className="lg:col-span-3 relative bg-gradient-to-br from-teal-400 via-teal-500 to-emerald-500 rounded-3xl p-10 min-h-[500px] overflow-hidden group hover:shadow-2xl transition-shadow duration-300">
            {/* Pattern Background */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 left-10 w-24 h-24 border-2 border-white rounded-2xl rotate-12"></div>
              <div className="absolute top-32 right-20 w-16 h-16 border-2 border-white rounded-full"></div>
              <div className="absolute bottom-20 left-32 w-20 h-20 border-2 border-white rounded-2xl -rotate-12"></div>
            </div>

            {/* Badge */}
            <div className="absolute top-8 left-8 px-6 py-3 bg-slate-900/80 backdrop-blur-sm rounded-full flex items-center gap-2 shadow-lg">
              <i className="ri-sparkling-line text-teal-300 text-lg"></i>
              <span className="text-white font-semibold text-sm uppercase tracking-wide">CLEANER</span>
            </div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col justify-between pt-24">
              <div className="flex justify-end">
                <div className="w-40 h-40 bg-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center">
                  <i className="ri-delete-bin-line text-7xl text-white"></i>
                </div>
              </div>

              <div>
                <h3 className="text-6xl font-bold text-white mb-4 leading-tight">
                  Device<br />Optimization
                </h3>
                <p className="text-white/80 text-base">Complete cleaning and performance enhancement</p>
              </div>
            </div>
          </div>
        </div>

        {/* Product Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16">
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900">VPN Application</h4>
            </div>
            <p className="text-base text-gray-600 leading-relaxed">
              Our VPN application provides military-grade encryption to protect your online privacy. With servers worldwide, enjoy fast and secure browsing on any network. Features include automatic connection, kill switch protection, and zero-logging policy to ensure your data remains private.
            </p>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center">
                <i className="ri-delete-bin-line text-2xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900">Cleaner Application</h4>
            </div>
            <p className="text-base text-gray-600 leading-relaxed">
              Keep your iOS device running at peak performance with our comprehensive cleaning solution. Remove junk files, optimize storage, manage photos and videos, and monitor battery health. Our intelligent algorithms identify unnecessary data while keeping your important files safe.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}